import React from "react"
import { graphql } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"
import Post from "../components/post"


class BlogIndex extends React.Component
{
  render()
  {
    const { data } = this.props
    const siteTitle = data.site.siteMetadata.title
    const posts = data.allMarkdownRemark.edges

    return (
      <Layout location={this.props.location} title={siteTitle}>
        <SEO />

        {/* 
        ///////////////////////////////////////////////
        // This code is to display entire posts */}
        {posts.map(({ node }, index) => (
          <Post node={node} key={index} />
        ))}


        {/* 
        ///////////////////////////////////////////////
        // This code is to display links to posts with excerpts
        //{posts.map(({ node }, index) => (
        //
        // <article key={node.fields.slug}>
        //   <header>
        //
        //     <Link className="article-title-link" to={node.fields.slug}>
        //       {node.frontmatter.title}
        //     </Link>
        //
        //     <p className="article-date">
        //       {node.frontmatter.date}
        //     </p>
        //   </header>
        //   <section>
        //     <p className="article-excerpt" dangerouslySetInnerHTML={{
        //       __html: node.excerpt.split("…")[0] + "...",
        //     }} />
        //     <Link className="article-excerpt-link" to={node.fields.slug}>
        //       more
        //     </Link>
        //   </section>
        // </article>
        //</article></article>))}
        /////////////////////////////////////////////// */}

      </Layout>
    )
  }
}

export default BlogIndex


///////////////////////////////////////////////
// This Query is to display entire posts 
export const pageQuery = graphql`
  query {
    site {
      siteMetadata {
        title
      }
    }
    allMarkdownRemark(sort: { fields: [frontmatter___date], order: DESC }) {
      edges {
        node {
          html
          frontmatter {
            title
            date
          }
        }
      }
    }
  }
`

///////////////////////////////////////////////
// This query is to display links to posts with excerpts
// export const pageQuery = graphql`
//   query {
//     site {
//       siteMetadata {
//         title
//       }
//     }
//     allMarkdownRemark(sort: { fields: [frontmatter___date], order: DESC }) {
//       edges {
//         node {
//           excerpt(pruneLength: 140)
//           html
//            fields {
//              slug
//            }
//           frontmatter {
//             title
//             date
//           }
//         }
//       }
//     }
//   }
// `